import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GenerateDateFromTimestampService {

    constructor() {
    }

    formatLastUpdateDate(tempDate) {
        const resultDate = new Date();
        resultDate.setFullYear(tempDate.substr(0, 4), tempDate.substr(5, 2) - 1, tempDate.substr(8, 2));
        resultDate.setHours(tempDate.substr(11, 2), tempDate.substr(14, 2), tempDate.substr(17, 2));
        return resultDate.toISOString();
    }
}
